module.exports = __webpack_public_path__ + "img/a6.d18ae246.webp";